import { useSettingsResource } from './useSettingsResource.js'

/**
 * The shape `/v1/checkout/settings` reads and writes.
 *
 * One object for all three checkout screens — design, Buy Now and COD — because
 * that is what the endpoint takes. A partial PUT per screen would let two tabs
 * open at once overwrite each other's half.
 */
export interface CheckoutSettings {
  brandName: string
  brandTagline: string
  brandLogo: string
  supportPhone: string
  themePrimary: string
  themeAccent: string
  themeRadius: number

  otpEnabled: boolean
  /** Whether shoppers are asked before their details reach marketing tools. */
  trackingRequiresConsent: boolean
  trackingConsentText: string
  codEnabled: boolean
  autofillEnabled: boolean
  saveCustomerDetails: boolean
  showTrustBadges: boolean

  buyNowEnabled: boolean
  buyNowLabel: string
  hideNativeBuyButton: boolean

  codFee: number
  codMaxOrderValue: number

  deliveryDaysMin: number
  deliveryDaysMax: number
}

/**
 * The checkout screens' view of the shared settings hook.
 *
 * Design, Buy Now and COD are three screens over one object, because that is
 * what the endpoint takes. Marketing has its own object and its own endpoint —
 * see `useMarketingSettings`.
 */
export function useCheckoutSettings() {
  return useSettingsResource<CheckoutSettings>('/v1/checkout/settings', 'checkout-settings')
}
